import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import SEO from './SEO';

export default function TermsPage() {
  // Scroll to top on mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <SEO
        title="Terms of Service"
        description="Read DreamableAI's Terms of Service. Understand the terms and conditions for using our AI greeting card creation platform."
        path="/terms"
      />
      <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto">
          <div className="bg-white rounded-lg shadow-lg p-8">
            <div className="text-center mb-8">
              <Link to="/" className="text-3xl font-bold text-purple-600 hover:text-purple-700 transition">
                🎨 DreamableAI
              </Link>
              <h1 className="mt-4 text-3xl font-bold text-gray-900">Terms of Service</h1>
              <p className="mt-2 text-gray-600">Last updated: {new Date().toLocaleDateString()}</p>
            </div>

          <div className="prose max-w-none">
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Acceptance of Terms</h2>
            <p className="mb-6 text-gray-700">
              By accessing and using DreamableAI, you accept and agree to be bound by the terms and provision of this agreement.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Service Description</h2>
            <p className="mb-6 text-gray-700">
              DreamableAI is an AI-powered greeting card creation platform that allows users to generate, customize, and share digital greeting cards.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. User Responsibilities</h2>
            <ul className="list-disc pl-6 mb-6 text-gray-700">
              <li>You are responsible for maintaining the confidentiality of your account</li>
              <li>You agree not to use the service for any unlawful purposes</li>
              <li>You will not upload content that infringes on others' rights</li>
              <li>You will respect the intellectual property rights of others</li>
            </ul>

            <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Content and Intellectual Property</h2>
            <p className="mb-6 text-gray-700">
              You retain ownership of the content you create using our service. However, you grant us a license to use, store, and display your content as necessary to provide the service.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Privacy</h2>
            <p className="mb-6 text-gray-700">
              Your privacy is important to us. Please review our{' '}
              <Link to="/privacy" className="text-purple-600 hover:text-purple-500">Privacy Policy</Link>{' '}
              to understand how we collect and use your information.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Limitation of Liability</h2>
            <p className="mb-6 text-gray-700">
              DreamableAI shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of the service.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Changes to Terms</h2>
            <p className="mb-6 text-gray-700">
              We reserve the right to modify these terms at any time. We will notify users of any significant changes.
            </p>

            <h2 className="text-2xl font-semibold text-gray-900 mb-4">8. Contact Information</h2>
            <p className="mb-6 text-gray-700">
              If you have any questions about these Terms of Service, please{' '}
              <Link to="/help" className="text-purple-600 hover:text-purple-500">contact our support team</Link>.
            </p>
          </div>

          <div className="mt-8 text-center">
              <Link
                to="/"
                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-purple-600 hover:bg-purple-700 transition"
              >
                ← Back to DreamableAI
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
} 